<template>
<v-container>
<v-row justify="center">
  <v-col cols=10 md=6>
       <h4 class="text-center mb-3">Zadaj email</h4>
        <v-row>
          <v-text-field
            validate-on-blur
            :rules="emailRules"
            v-model="email"
            label="Email"
            clearable
            @keyup.enter="confirmUserInfo"
          ></v-text-field>
        </v-row>
         <h4 class="text-center my-3">Zadaj poznámku pre upratovača</h4>
        <v-row>
        <v-textarea
          persistent-hint
          hint="nepovinné"
          solo
          v-model="note"
          label="Poznámka pre upratovača"
          @keyup.enter="confirmUserInfo"
          @blur="confirmUserInfo"
          placeholder='Tu môžeš napísať dodatočné požiadavky pre upratovača. Napr. "Chcem poskladať uterák do tvaru labute"'
        ></v-textarea>
      </v-row>
      <v-row justify="center">
        <v-btn
          color="accent darken-1"
          class="white--text"
          @click="confirmUserInfo"
        >
          OK
        </v-btn> 
      </v-row> 
  </v-col>
 </v-row>
</v-container>
</template>

<script>
  export default {
    name: "UserInfo",
    props: [
      'cleaningType',
      'refForm'
    ],
    data () {
      return {
        email: '',
        note: '',
        emailRules: [
        v => !!v || 'Zadajte e-mail',
        v => (/.+@.+/.test(v)) || 'E-mail je neplatný',
        ],
      }
    },
    methods: {
      confirmUserInfo() {
        this.refForm.validate();
        const regex = /.+@.+/;
        if(!!this.email && regex.test(this.email)){
          this.refForm.resetValidation();
          this.$emit('change', {email: this.email, note: this.note});
        }
      },  
    }
  }
</script>

